import React, { useEffect, useState } from 'react';
import { usePagination, withPaginate } from '@contexts/Paginate/PaginateContext';
import { compose } from 'redux';
import rootApi from '@utils/baseAPI/WrapperApi';
import { useQuery } from 'react-query';
import moment from 'moment';
import { Box } from '@mui/system';
import ActViewDetail from './ActionTable/ActViewDetail';
import DialogsViewDetail from './Dialogs/DialogsViewDetail';
import DialogsChangeRole from './Dialogs/DialogsChangeRole';
import ActChangeRole from './ActionTable/ActChangeRole';
import ActDeleteUser from './ActionTable/ActDelete';
import RequestButton from './BtnRequest';
import FilterTable from './FilterTable';
import { Card, Col, Row, Table, Typography } from 'antd';
import { Stack } from '@mui/material';
import Status from './Status';
import DeleteConfirmationModal from './Dialogs/DialogsDelete';
import ActionMenu from './ActionTable/ActionMenu';
import BlockModal from './Dialogs/DialogsBlock';
import { role_options } from './BtnRequest/RequestDialog';

const getColumns = ({
  refetch,
  setOpen,
  setOpenView,
  setOpenDelete,
  setUserInfo,
  setOpenBlocked
}) => {
  return [
    {
      title: 'Tên đăng nhập',
      dataIndex: 'user_name',
      render: (_, d) => (
        <Typography style={{ fontSize: '14px', fontWeight: 500, color: '#00904A' }}>
          {d?.user_name}
        </Typography>
      ),
      width: 220
    },
    // {
    //   title: 'Số điện thoại',
    //   dataIndex: 'phone_number',
    //   render: (_, d) => (
    //     <Stack direction={'column'} spacing={1}>
    //       <Typography style={{ fontSize: '14px', fontWeight: 400, color: '#192434' }}>
    //         {d?.phone_number}
    //       </Typography>
    //     </Stack>
    //   )
    // },
    // {
    //   title: 'Địa chỉ Email',
    //   dataIndex: 'email',
    //   render: (_, d) => (
    //     <Typography style={{ fontSize: '14px', fontWeight: 400, color: '#192434' }}>
    //       {d?.email}
    //     </Typography>
    //   )
    // },
    {
      title: 'Nhóm quyền',
      dataIndex: 'roles',
      render: (_, d) => (
        <Typography style={{ fontSize: '14px', fontWeight: 400, color: '#192434' }}>
          {role_options.find((item) => item.value === d?.role)?.label || 'Chưa gán'}
        </Typography>
      )
    },
    {
      title: 'Nhóm',
      dataIndex: 'group',
      render: (_, d) => (
        <Typography style={{ fontSize: '14px', fontWeight: 400, color: '#192434' }}>
          {d?.group ? d?.group : 'Chưa gán'}
        </Typography>
      )
    },
    {
      title: 'Thời gian tạo',
      dataIndex: 'created_at',
      render: (_, d) => (
        <Typography style={{ fontSize: '14px', fontWeight: 400, color: '#192434' }}>
          {moment(d.created_at).format('DD-MM-YYYY HH:mm')}
        </Typography>
      )
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      render: (_, d) => <Status d={d} />,
      width: 160
    },
    {
      title: 'Hành động',
      width: 180,
      dataIndex: 'actions',
      render: (_, d) => (
        <>
          <ActViewDetail userInfo={d} setUserInfo={setUserInfo} setOpenView={setOpenView} />
          {/* <ActChangeRole userInfo={d} setUserInfo={setUserInfo} setOpen={setOpen} /> */}
          <ActDeleteUser userInfo={d} setUserInfo={setUserInfo} setOpenDelete={setOpenDelete} />
          {/* <ActionMenu
            row={d}
            setOpenDelete={setOpenDelete}
            setSelectedRow={setUserInfo}
            setOpenBlocked={setOpenBlocked}
          /> */}
        </>
      )
    }
  ];
};
const ListUserOperator = () => {
  const [open, setOpen] = React.useState(false);
  const [openView, setOpenView] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [openBlocked, setOpenBlocked] = useState(false);
  const [userInfo, setUserInfo] = React.useState(null);
  const [dataFilter, setDataFilter] = React.useState();
  const [flagSearch, setFlagSearch] = React.useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const { data, isLoading, refetch, error, isSuccess } = useQuery(
    ['admin-get-user-operator', currentPage, pageSize],
    () =>
      rootApi.get(`/api/users/search`, {
        params: {
          page: currentPage,
          size: pageSize,
          keyWord: dataFilter?.search_username ?? undefined,
          status: dataFilter?.status ?? undefined
        }
      })
  );
  useEffect(() => {
    refetch();
  }, [flagSearch]);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleChangePageSize = (current, size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (data?.data) {
      setTotalItems(data.data.meta?.total);
    }
  }, [data]);

  return (
    <>
      <DialogsViewDetail
        openView={openView}
        setOpenView={setOpenView}
        userInfo={userInfo}
        refetch={refetch}
      />
      {/* <DialogsChangeRole open={open} setOpen={setOpen} userInfo={userInfo} refetch={refetch} /> */}
      <DeleteConfirmationModal
        visible={openDelete}
        setVisible={setOpenDelete}
        userInfo={userInfo}
        refetch={refetch}
      />
      {/* <BlockModal
        visible={openBlocked}
        setVisible={setOpenBlocked}
        userInfo={userInfo}
        refetch={refetch}
      /> */}
      <Row justify="space-between" align="middle">
        <Col>
          <Typography.Title level={4}>Quản lý người dùng</Typography.Title>
        </Col>
        <Col>
          <RequestButton refetch={refetch} />
        </Col>
      </Row>
      <Box width="100%" overflow="auto">
        <Card>
          <FilterTable
            dataFilter={dataFilter}
            onChange={setDataFilter}
            flagSearch={flagSearch}
            setFlagSearch={setFlagSearch}
            users={data?.data.data}
          />
          <Table
            bordered
            size="small"
            loading={isLoading}
            dataSource={data?.data.data || []}
            columns={getColumns({
              refetch,
              setOpen,
              setOpenView,
              setOpenDelete,
              setUserInfo,
              setOpenBlocked
            })}
            pagination={{
              current: currentPage,
              pageSize: pageSize,
              total: totalItems,
              showSizeChanger: true,
              onChange: handleChangePage,
              onShowSizeChange: handleChangePageSize,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
            }}
            style={{ borderRadius: '4px', thead: { backgroundColor: '#DBDFE5', color: '#626D7C' } }}
            scroll={{ x: 'max-content' }}
          />
        </Card>
      </Box>
    </>
  );
};

export default compose(withPaginate)(ListUserOperator);
